import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMovingArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17 8.9502L2 8.95019",
		stroke: "#D8D9DC",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 15.9502L0.999999 8.95019L8 1.9502",
		stroke: "#D8D9DC",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgMovingArrow;
